import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import crStyles from "../../../customerReservation/crStyles";
import styles from "../OrderDetailsNewVersion.module.scss";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import {
  StyledBasicExpansionPanel,
  StyledBasicExpansionPanelSummary,
} from "../../../../shared/ExpansionPanels/ExpansionPanel";
import { FINANCE, PRIVATE_LEASE, LEASE } from "../../../../common/Constants";
import LowerCaseText from "../../../../utils/LowerCaseText";
import FinanceBreakdown from "../financeBreakdown/FinanceBreakdown";
import PrivateLeaseBreakdown from "../privateLeaseBreakdown/privateLeaseBreakdown";
import FinanceAndLeaseBreakDownHercules from "../financeBreakdown/FinanceAndLeaseBreakDownHercules";

class PaymentDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      paymentDetailsExpansion: false,
    };
    this.userAgentHercules =
      this.props.user.permissions.rolePermissions.hasOwnProperty(
        "herculesPricingStack"
      );
  }

  flipIcon() {
    this.setState({
      paymentDetailsExpansion: !this.state.paymentDetailsExpansion,
    });
  }

  expandFinanceQuote() {
    this.setState({ financeQuoteExpansion: !this.state.financeQuoteExpansion });
  }

  render() {
    const paymentType = this.props.customerReservation.paymentType;
    const { tradeInDetails } = this.props;
    return (
      <div>
        <StyledBasicExpansionPanel
          defaultExpanded={false}
          onChange={() => this.flipIcon()}
        >
          <StyledBasicExpansionPanelSummary
            style={crStyles.headerBarNeutral}
            data-testid="paymentDetails"
          >
            <div className={styles.headerBar}>
              <div className={styles.boldHeader}>
                {this.props.t("OrderDetails.paymentDetailsTitle")}
              </div>
              <div>
                {this.state.paymentDetailsExpansion ? (
                  <ExpandLessIcon data-testid="lessSummary" />
                ) : (
                  <ExpandMoreIcon data-testid="moreSummary" />
                )}
              </div>
            </div>
            <br />
          </StyledBasicExpansionPanelSummary>

          <div className={styles.sectionInfoGrid}>
            <div className={styles.bottomBorder}></div>

            {/*{LowerCaseText(paymentType) === CASH &&*/}
            {/*  (this.userAgentHercules ? (*/}
            {/*    <CashBreakDownHercules*/}
            {/*      {...this.props}*/}
            {/*      customerInfoData={customerInfo}*/}
            {/*      defaultCurrency={*/}
            {/*        this.props.localizedInfo.defaultCurrency.symbol*/}
            {/*      }*/}
            {/*      offlinePricingUpdate={*/}
            {/*        customerReservation.offlinePricingUpdate*/}
            {/*          ? customerReservation.offlinePricingUpdate*/}
            {/*          : {}*/}
            {/*      }*/}
            {/*      customerReservationStatus={customerReservation.status}*/}
            {/*      pricingStack={customerReservation.pricingStack}*/}
            {/*      tradeIn={tradeInDetails}*/}
            {/*      market={*/}
            {/*        this.props.fromCrc*/}
            {/*          ? this.props.selectedMarket*/}
            {/*          : this.props.user.market*/}
            {/*      }*/}
            {/*      nameplate={customerReservation.nameplate}*/}
            {/*    />*/}
            {/*  ) : (*/}
            {/*    <CashBreakdown*/}
            {/*      {...this.props}*/}
            {/*      defaultCurrency={*/}
            {/*        this.props.localizedInfo.defaultCurrency.symbol*/}
            {/*      }*/}
            {/*      market={*/}
            {/*        this.props.fromCrc*/}
            {/*          ? this.props.selectedMarket*/}
            {/*          : this.props.user.market*/}
            {/*      }*/}
            {/*      nameplate={this.props.customerReservation.nameplate}*/}
            {/*    />*/}
            {/*  ))}*/}

            {LowerCaseText(paymentType) === FINANCE &&
              (this.userAgentHercules ? (
                // <FinanceAndLeaseBreakDownHercules
                //   {...this.props}
                //   market={
                //     this.props.fromCrc
                //       ? this.props.selectedMarket
                //       : this.props.user.market
                //   }
                //   defaultCurrency={
                //     this.props.localizedInfo.defaultCurrency.symbol
                //   }
                //   tradeIn={tradeInDetails}
                //   pricingStack={customerReservation.pricingStack}
                // />
                ""
              ) : (
                <FinanceBreakdown
                  {...this.props}
                  defaultCurrency={
                    this.props.localizedInfo.defaultCurrency.symbol
                  }
                />
              ))}

            {LowerCaseText(paymentType) === LEASE &&
              (this.userAgentHercules ? (
                <FinanceAndLeaseBreakDownHercules
                  {...this.props}
                  defaultCurrency={
                    this.props.localizedInfo.defaultCurrency.symbol
                  }
                  tradeIn={tradeInDetails}
                />
              ) : (
                ""
              ))}

            {LowerCaseText(paymentType) === PRIVATE_LEASE && (
              <PrivateLeaseBreakdown {...this.props} />
            )}
          </div>
        </StyledBasicExpansionPanel>
      </div>
    );
  }
}

export default withTranslation("emp")(PaymentDetails);
